module.exports = __webpack_public_path__ + "67469684296e580c5db57776ed66ae25.svg";